<template>
    <div class="login">
        <h1>Aanvraagformulier</h1>

        <v-row justify="center">
            <v-col cols="12" sm="6">
                <v-card>
                    <v-card-text>
                        <v-form @submit.prevent="submit">
                            <v-alert
                                v-for="(errorMessage, index) in this.errorMessages"
                                :key="`errorMessage-${index}`"
                                type="error"
                            >
                                {{ errorMessage }}
                            </v-alert>

                            <v-text-field :value="application.uniqueToken" readonly label="Aanvraag"></v-text-field>
                            <v-birthday-picker v-model="applicant.birthdate" label="Geboortedatum"></v-birthday-picker>

                            <v-row>
                                <v-spacer></v-spacer>
                                <v-col cols="auto">
                                    <v-btn
                                        color="primary"
                                        @click="submit"
                                        :loading="submitBtnClicked"
                                        :disabled="submitting"
                                        >Starten</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VBirthdayPicker from '@/components/VBirthdayPicker';

export default {
    name: 'login',
    components: {
        VBirthdayPicker,
    },
    data: () => ({
        submitting: false,
        backBtnClicked: false,
        submitBtnClicked: false,

        errorMessages: [],
        application: {
            uniqueToken: null,
        },
        applicant: {
            birthdate: null,
        },
    }),
    created() {
        this.application.uniqueToken = this.$route.params.token;
    },
    computed: {
        ...mapGetters([]),
    },
    methods: {
        ...mapActions(['login']),
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;

            // reset error messages
            this.errorMessages = [];

            // do login
            this.login(this.$data)
                .then(function() {
                    that.$router.push({ name: 'step1_reason' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (Array.isArray(response.data.error.messages)) {
                        that.errorMessages = response.data.error.messages;
                        return;
                    }
                    that.errorMessages = [response.data.error.messages];
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
